export default __webpack_public_path__ + "static/media/Q17.2cbcff2a.jpg";